import { Observable, from } from 'rxjs';
import { IMeasurementUnit } from '@/interfaces/measurement-unit';
import { map } from 'rxjs/operators';
import { apiClient } from '@/services/api';
import { ENDPOINTS } from '@/settings/api-settings';

function listAll(): Observable<IMeasurementUnit[]> {
  return from(apiClient.get(ENDPOINTS.MEASUREMENT)).pipe(
    map((r: any) => r.data),
  );
}

export { listAll };
